import { createAction } from '@reduxjs/toolkit';
import { Constants as constants } from './constants';
import { AllIntentsType } from '../intent.type';

export const storeIntentsStats = createAction<AllIntentsType>(constants.STORE_INTENT_STATS);
export const storeEntityStats = createAction<AllIntentsType>(constants.STORE_ENTITY_STATS);
